export default __webpack_public_path__ + "static/media/logo.edee0742.png";